import React from 'react'
import { FormattedMessage } from 'react-intl'
import { MaterialLoader } from 'components/loaders'

import styles from './refreshLayer.styl'

const RefreshLayer = () => {
  return (
    <div className={styles.reloader}>
      <div className={styles.reloadNote}>
        <div className="base-margin--bottom">
          <FormattedMessage
            id="label.content_update"
            defaultMessage="Please wait. Updating content..."
          />
        </div>
        <MaterialLoader size={60} />
      </div>
    </div>
  )
}

export default RefreshLayer
